<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap gap-1">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="px-3 py-2 text-gray-400 text-sm leading-4 border border-gray-200 rounded bg-white" v-html="link.label" />
        <Link v-else :key="`link-${key}`" class="px-3 py-2 focus:text-indigo-600 text-sm leading-4 hover:bg-white border border-gray-200 focus:border-indigo-500 rounded transition" :class="{ 'bg-white text-indigo-600 font-bold shadow-sm': link.active }" :href="link.url" v-html="link.label" />
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    links: Array,
  },
}
</script>
